/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const JobStatus = core.serialization.enum_([
    "created",
    "planning",
    "scheduled",
    "ready",
    "executing",
    "complete",
    "failed",
    "canceled",
    "waiting",
]);
